import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectBuildingHandOver = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('hand_over')(jsonQuery),
);
